<template>
  <div class="elements-panel">
    <!-- Tab Header -->
    <div class="panel-tabs">
      <!-- Original:
      <button 
        class="panel-tab" 
        :class="{ active: activeTab === 'basic' }"
        @click="activeTab = 'basic'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 4.5L17.55 7.05L15 9.6L12.45 7.05L15 4.5ZM7.5 5V9H3.5V5H7.5ZM17.5 15V19H13.5V15H17.5ZM7.5 15V19H3.5V15H7.5ZM15 2L9.5 7.5L15 13L20.5 7.5L15 2ZM9.5 3H1.5V11H9.5V3ZM19.5 13H11.5V21H19.5V13ZM9.5 13H1.5V21H9.5V13Z" fill="currentColor"/>
        </svg>
        <span>Basic Elements</span>
      </button>
      Hide temporarily. Save for future development
      <button 
        class="panel-tab" 
        :class="{ active: activeTab === 'form' }"
        @click="activeTab = 'form'"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM8 10H16V12H8V10ZM8 14H16V16H8V14ZM8 6H16V8H8V6Z" fill="currentColor"/>
        </svg>
        <span>Form Elements</span>
      </button>
      -->
      <Tab
        v-model="activeTab"
        type="underline"
        :tabs="panelTabs"
        :icon_size="24"
        :equal_width="true"
      >
        <template #icon-0>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 4.5L17.55 7.05L15 9.6L12.45 7.05L15 4.5ZM7.5 5V9H3.5V5H7.5ZM17.5 15V19H13.5V15H17.5ZM7.5 15V19H3.5V15H7.5ZM15 2L9.5 7.5L15 13L20.5 7.5L15 2ZM9.5 3H1.5V11H9.5V3ZM19.5 13H11.5V21H19.5V13ZM9.5 13H1.5V21H9.5V13Z" fill="currentColor"/>
          </svg>
        </template>
        <!-- When Form Elements tab is re-enabled, add: -->
        <!-- <template #icon-1>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM8 10H16V12H8V10ZM8 14H16V16H8V14ZM8 6H16V8H8V6Z" fill="currentColor"/>
          </svg>
        </template> -->
      </Tab>
    </div>
    <div v-if="activeTab === 'basic'" class="panel-content">
      <!-- Panel Description -->
      <div class="panel-description">
        Basic Elements can be combined into a Form Element, or directly used in a form. To use an Element, drag and drop it at the draft area in the middle of the screen.
      </div>

      <!-- Elements Sections -->
      <div class="elements-sections">
        <ElementSection
          v-for="section in sections"
          :key="section.key"
          :title="section.title"
          :elements="section.elements"
          :default-expanded="true"
          :disabled="disabled"
          @element-drag-start="handleElementDragStart"
          @element-drag-end="handleElementDragEnd"
        />
      </div>
    </div>
    <div v-else-if="activeTab === 'form'" class="panel-content">
      <!-- Panel Description -->
      <div class="panel-description">
        Coming soon...
      </div>
    </div>
  </div>
</template>

<script>
import ElementSection from './ElementSection.vue';
import { getSectionsArray } from './elementsData.js';

export default {
  name: 'ElementsPanel',
  components: {
    ElementSection
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 'basic',
      panelTabs: [
        { value: 'basic', label: 'Basic Elements', icon: true },
        // { value: 'form', label: 'Form Elements', icon: true }, // Hide temporarily. Save for future development
      ],
      sections: getSectionsArray()
    };
  },
  emits: ['drag-start', 'drag-end'],
  methods: {
    handleElementDragStart(element) {
      this.$emit('drag-start', element);
    },
    handleElementDragEnd() {
      this.$emit('drag-end');
    }
  }
};
</script>

<style scoped>
.elements-panel {
  display: flex;
  flex-direction: column;
  background: #fff;
  box-shadow: 0px 1px 15px 0px rgba(164, 164, 164, 0.25);
  height: 100%;
  overflow: hidden;
}

.panel-tabs {
  padding: 8px 8px 0 8px;
  flex-shrink: 0;
}

/* Original panel-tab styles (replaced by library Tab component):
.panel-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 50%;
  flex:1;
  padding: 4px 16px;
  background: #fff;
  border: none;
  border-bottom: 1px solid #E6E6E6;
  color: #666;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.panel-tab:hover {
  color: #004879;
}

.panel-tab.active {
  color: #004879;
  border-bottom: 2px solid #004879;
  font-weight: 500;
}

.panel-tab svg {
  width: 24px;
  height: 24px;
}
*/
.panel-content{
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.panel-description {
  padding: 16px 24px;
  color: #666;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-align: justify;
  flex-shrink: 0;
}

.elements-sections {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
